import { useMemo } from 'react';
import { VehicleInfo } from '../types';

type UsePrimaryImageUrl = (vehicleData: VehicleInfo | undefined) => string;

const usePrimaryImageUrl: UsePrimaryImageUrl = (vehicleData) => {
  const primaryImageUrl = useMemo<string>(() => {
    if (vehicleData?.vehicleType === 'new') {
      const vehicleMediaImages = vehicleData?.vehicleMedia?.mediaImages;

      if (vehicleMediaImages?.length) {
        const primaryImage = vehicleMediaImages?.find(
          (vehicleImage) => vehicleImage.imageType === '3_4th_front_facing',
        );
        return primaryImage?.url ?? '';
      }
    }
    return vehicleData?.modelImageFromScs ?? '';
  }, [vehicleData]);

  return primaryImageUrl;
};

export default usePrimaryImageUrl;
